import React from 'react';

import { SituationLabelContainer } from './styles';

const situationColors = {
    Ativo: '#0B8A1C',
    Encerrado: '#EC130F',
    Inadimplente: '#EC130F',
    Suspenso: '#EC130F',
    'Em implantação': '#0B7EB5',
};

export default function SituationLabel({ contrastTheme, situation }) {
    return (
        <SituationLabelContainer contrastTheme={contrastTheme} color={situationColors[situation]}>
            {situation}
        </SituationLabelContainer>
    );
}
